import styled from 'styled-components';
import React from 'react';
import {Link} from 'react-router-dom';

const TeamsWrapper=styled.div`
    grid-column:1;
    grid-row:1/4;
    background-color:#362234;
    color:#958993;
`;
const TeamList=styled.div`
    width:100%;
    padding:10px;
    list-style:none;
`;
const TeamListItem=styled.div`
    height:50px;
    widht:50px;
    background-color:#676066;
    color: #fff;
    margin:auto;
    margin-bottom:10px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:24px;
    border-radius:11px;
    &:hover{
        border-style:solid;
        border-width:thick;
        border-color:#767676;
    }
`;

const team=({id,letter})=>(
    <Link to={`/view-team/${id}`}><TeamListItem key={`team-${id}`}>{letter}</TeamListItem></Link>
);
export default ({teams})=>(
    <TeamsWrapper>
        <TeamList>
            {teams.map(team)}
            <Link to={`/create-team/`}><TeamListItem key={`team-add`}>+</TeamListItem></Link>
        </TeamList>

    </TeamsWrapper>
);